import React, { useContext } from 'react'
import { PublicHeader } from '../components/headers/PublicHeader'
import { Navigate, Outlet } from 'react-router-dom'
import { PublicFooter } from '../components/footers/PublicFooter'
import { DContext } from '../context/Datacontext'
import Loading from '../features/Loading'

export const PublicLayout = () => {
  const { isAuth, currentUser } = useContext(DContext);

  if (isAuth == null) return <Loading/>


  if (isAuth) {
    if (currentUser?.role === 'user') {
      return <Navigate to="/learner/courses" replace />;
    }
    return <Navigate to="/app/dashboard" replace />;
  }
  return (
    <div>
      <PublicHeader />
      <Outlet />
      <PublicFooter />
    </div>
  )
}
